import Business from './Business';

export default Business;


// WEBPACK FOOTER //
// ./src/components/Query/Business/index.ts